import { detailed } from './detailed';
import { general } from './general';

export const archived_stats = {
  namespaced: true,
  modules: {
    detailed,
    general
  }
};
